

















import { computed, defineComponent, PropType, ref, watch } from "@vue/composition-api";
import { Participant } from "@scrile/api-provider/dist/api/ParticipantProvider";
import { $t } from "@/lib/i18nHelpers";
import PersonalIdForm from "@/views/PageBecomeCreator/components/LimitedCreatorForm/components/PersonalIdForm.vue";
import PersonalInfoForm from "@/views/PageBecomeCreator/components/LimitedCreatorForm/components/PersonalInfoForm.vue";

export default defineComponent({
  name: "ConsentIdentityForm",
  components: { PersonalIdForm, PersonalInfoForm },
  props: {
    participant: { type: Object as PropType<Participant>, required: true },
  },
  setup(props, { emit }) {
    const loading = ref<Record<string, boolean>>({ id: false, info: false });
    const infoValid = ref(false);
    const idValid = ref(false);

    const info = computed(() => {
      return [
        {
          name: $t("Shooting location"),
          value: props.participant.shootingLocation || "-",
        },
        {
          name: $t("Shooting date(s)"),
          value: props.participant.shootingDate || "-",
        },
      ];
    });

    const showLoader = computed(() => Object.values(loading.value).some(v => v));

    const checkValid = () => {
      emit("setValid", infoValid.value && idValid.value);
    };

    watch([idValid, infoValid], checkValid, { immediate: true });

    return { showLoader, loading, infoValid, idValid, info };
  },
});
